import _ from 'lodash';

class TableGridController {
  constructor($scope) {
    this.name = 'tableGrid';
    this.descending = [];
    this.$scope = $scope;
    this.setDescendingFlagsForAllColumns(false);
    this.sortIconClass = {
      ascending: 'sort-ascending',
      descending: 'sort-descending'
    };

    this.isAllRowsSelected = false;
    this.rowsSelected = 0;

    if(_.find(this.columns, 'headerCheckboxable')){
      this.rowsSelected =  _.size(this.metaData[this.options.dataSet].selectedValues);
      this.watchRowsSelection();
    }
  }

  checkDisabledData(){
    return  this.data.length === 0 || _.size(_.filter(this.data, (i) => i.isDisabled)) === this.data.length;
  }

  watchRowsSelection(){
    this.$scope.$watch('vm.rowsSelected', this.updateCheckbox.bind(this));
  }

  updateCheckbox(newValue){
    const filterReadOnlyData = _.size(_.reject(this.data, (i) => i.isReadOnly));
    
    if(filterReadOnlyData > 0 && newValue === filterReadOnlyData){
      this.isAllRowsSelected = true;
    }else{
      this.isAllRowsSelected = false;
    }
  }

  checkForHiddenColumn(){
    const hideColumn = _.find(this.columns, 'hide');
    if(hideColumn){
      const columnData = hideColumn.hideIfEmpty ? _.filter(this.data, hideColumn.name) : [];
      if(_.isEmpty(columnData)){
        this.columns = this.columns.filter((column) => {
          return column.name !== hideColumn.name;
        });
      }
    }
  }

  sort(columnName) {
    let column = this.getColumnByName(columnName);
    column[columnName] = !column[columnName];
    this.toggleSort({
      columnName: columnName,
      descendingFlag: column[columnName]
    });
  }

  checkboxToggle(columnName, isAllRowsSelected) {
    this.toggleHeaderCheckbox({columnName: columnName, selectAllFlag: isAllRowsSelected});
  }

  getColumnByName(columnName) {
    return _.find(this.descending, (o) => _.keys(o).indexOf(columnName)>-1);
  }

  getSortIconClass(columnName) {
    let column = this.getColumnByName(columnName);
    if (column[columnName]) {
      return this.sortIconClass.descending;
    } else {
      return this.sortIconClass.ascending;
    }
  }

  setDescendingFlagsForAllColumns(defaultDescendingFlag) {
    if (this.sortBy) {
      let updatedDescendingFlag = this.sortBy.order === 'asc' ? false : true;
      _.each(this.columns, (column) => {
        let data = {};
        let hasUpdatedDescendingFlag= this.sortBy.column === column.name;
        data[column.name] = hasUpdatedDescendingFlag ? updatedDescendingFlag : defaultDescendingFlag;
        this.descending.push(data);
      });
    }
  }
}

TableGridController.$inject = ['$scope'];
export
default TableGridController;



// WEBPACK FOOTER //
// ./app/components/tableGrid/tableGrid.controller.js